import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
import { ref, Ref } from "@vue/composition-api";

export const table_config: Ref<ITableConfig> = ref({
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
    },
    {
      name: "Information",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
    },
    {
      name: "Severity",
      key: "high",
      spanMin: "11rem",
      spanMax: "11rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
    },
    {
      name: "Severity",
      key: "medium",
      spanMin: "11rem",
      spanMax: "11rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
    },
    {
      name: "Severity",
      key: "low",
      spanMin: "11rem",
      spanMax: "11rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
    },
    {
      name: "Last incident",
      key: "last_incident",
      spanMin: "14rem",
      spanMax: "14rem",
      sortable: false,
      isSortActive: false,
      filterable: false,
      sortDir: SORTING_DIR.DESC,
    },
    {
      name: "Content sensitivity",
      key: "sensitivity",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
    },
  ],
});
